import React, { useState, useEffect } from "react";
import { Spinner, Table } from "react-bootstrap";
import {
  useGenerateInvoiceBackendMutation,
  useGetInvoiceAddressInfoQuery,
  useGetAllInvoicesByIdQuery,
} from "./ProcurementApiSlice";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import { toast } from "react-toastify";
import { selectCurrentRoles } from "features/auth/authSlice";
import { useSelector } from "react-redux";
import {
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Tooltip,
} from "@mui/material";
import swal from "sweetalert";

import { Alert, Row, Col } from "react-bootstrap";

const InvoiceGenerationAdmin = ({
  stockUserId,
  stockCropId,
  procList,
  setBillModal,
  refetch,
  entity_type,
}) => {
  const RolesFromToken = useSelector(selectCurrentRoles);
  var user_id = RolesFromToken.organization_id;
  // const [selectedAddresses, setSelectedAddresses] = useState([]);
  // const [currentAddress, setCurrentAddress] = useState("");
  // const [currentQuantity, setCurrentQuantity] = useState("");
  let procId =
    procList?.entity_type === "Seller"
      ? procList?.trade_procCode
      : procList?.ProcCode;

  // const { data: invoiceAddress  } = useGetInvoiceAddressInfoQuery({stockUserId,stockCropId});
  const {
    data: invoiceAll,
    refetch: refetchInvoiceAll,
  } = useGetAllInvoicesByIdQuery(procId);
  //  const[addressData,setInvoiceAddress]=useState([])
  const [generateInvoice] = useGenerateInvoiceBackendMutation();

  const [showLoading, setshowLoading] = useState(false);
  const [generatedInvoices, setgeneratedInvoices] = useState([]);

  //  const[selectedAddMore,setSelectedAddMore]=useState(false)
  useEffect(() => {
    // setInvoiceAddress(invoiceAddress?.data)
    if (invoiceAll) {
      setgeneratedInvoices(invoiceAll?.data);
    }
  }, [invoiceAll]);

  const isSeller =
    procList?.entity_type === "Seller"
      ? procList.document_status?.b2s_invoice
      : procList?.entity_type === "Procurement Admin"
      ? procList.document_state?.b2s_invoice
      : procList.document_status?.b2s_invoice;

  const handleSubmitInvoice = () => {
    setshowLoading(true);

    // let finalData = addressData?.filter((item) => item.id === currentAddress)
    // setSelectedAddresses({
    //   location: `${finalData[0].address} ${finalData[0].district} ${finalData[0].state}`,
    //   stock_location: finalData[0].id ,
    //   quantity: parseFloat(currentQuantity),
    // })

    // setCurrentAddress("");
    // setCurrentQuantity("");
    let payload = {
      invoice_type: "bill_to_ship_to",
      user_id: user_id,
      entity_type: entity_type,
      // stock_locations: finalData.map((entry) => ({
      //   stock_location: entry.id,
      //   quantity: parseFloat(currentQuantity),
      // })),
      ProcCode:
        procList?.entity_type === "Seller"
          ? procList?.trade_procCode
          : procList?.ProcCode,
      quantity: procList?.final_quantity,
    };
    // let id = procList?.ProcCode;
    generateInvoice(payload)
      .unwrap()
      .then(async (data) => {
        toast.success("Invoice generated Successfully !!!");
        setshowLoading(false);
        refetchInvoiceAll();
        // setSelectedAddresses([])
        // setSelectedAddMore(false)
        await refetch();
      })
      .catch((data) => {
        toast.error(`${data.data.message}`);
        setshowLoading(false);
        // setSelectedAddresses([])
        // setSelectedAddMore(false)
        return;
      });
  };
  // const handleAddAddress = () => {
  //   let finalData = addressData.filter((item) => item.id === currentAddress)
  //   if (currentAddress && currentQuantity) {
  //     setSelectedAddresses((prev) => [
  //       ...prev,
  //       {
  //         location: `${finalData[0].address} ${finalData[0].district} ${finalData[0].state}`,
  //         stock_location: finalData[0].id ,
  //         quantity: parseFloat(currentQuantity),
  //       },
  //     ]);
  //     setCurrentAddress("");
  //     setCurrentQuantity("");
  //     setSelectedAddMore(true)
  //   }
  // };

  const handleDownload = (fileUrl) => {
    if (fileUrl) {
      window.open(fileUrl, "_blank");
    }
  };
  // const handleChangeAddress=(e)=>{
  //   setCurrentAddress(e.target.value)
  //   let finalData = addressData.filter((item) => item.id === e.target.value)
  //      setCurrentQuantity(finalData[0].quantity)
  // }

  return (
    <>
      {/* <div className="row">
      <div className="col-lg-8">
      <FormControl fullWidth variant="outlined" margin="normal">
        <InputLabel id="address-select-label">Select Address</InputLabel>
        <Select
          labelId="address-select-label"
          value={currentAddress}
          onChange={(e) => handleChangeAddress(e)}
          label="Select Stock Location"
          className="bgWhite"
        >
          {addressData?.map((address) => (
            <MenuItem key={address.id} value={address.id}>
              {address.address}, {address.state}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      </div>
      <div className="col-lg-4">
      <TextField
        label="Quantity"
        type="number"
        value={currentQuantity}
        onChange={(e) => setCurrentQuantity(e.target.value)}
        margin="normal"
        className="bgWhite"
        fullWidth
      />
          </div>
    
    </div> */}
      <div>
        {/* <p className="text-center text-successs">
            {procList?.entity_type==="Seller"?
            <b>
                {procList.document_status?.b2s_invoice ||
                procList.document_status?.normal_invoice
                  ? "Invoice Already Generated"
                  : ""}
              </b>
              :
              <b>
                {procList.document_state?.b2s_invoice ||
                procList.document_state?.normal_invoice
                  ? "Invoice Already Generated"
                  : ""}
              </b>
}
            </p>
          
            <div className="text-center mt-3 mb-4">
              <Button
                variant="contained"
                color="success"
                size="small"
                className="mx-2"
                onClick={handleSubmitInvoice}
           
                disabled={
                  procList
                    ? (entity_type === "Seller"
                      ? (procList.document_status?.b2s_invoice || procList.document_status?.normal_invoice)
                      : entity_type === "Procurement Admin"
                      ? (procList.document_state?.b2s_invoice || procList.document_state?.normal_invoice)
                      : false) 
                   
                    : false
                }
                
                  >
                Generate Invoice &nbsp;{showLoading ? <Spinner size="sm" /> : ""}
              </Button>
          
            </div> */}

        <Row className="justify-content-center">
          <Col md={12} lg={12}>
            {isSeller ? (
              <Alert variant="success" className="text-center">
                <strong>Invoice Already Generated</strong>
                <p className="mb-0">
                  The invoice for this transaction has already been generated
                  successfully. No further action is required.
                </p>
              </Alert>
            ) : (
              <Alert variant="info" className="text-center">
                <strong>Generate Invoice</strong>
                <p className="mb-0">
                  To generate the invoice for the traded quantity{" "}
                  <strong> {procList?.final_quantity} </strong>, click on the
                  <strong> Generate Invoice</strong> button below.
                </p>
              </Alert>
            )}

            <div className="text-center mt-3">
              <Button
                variant="contained"
                color="success"
                size="small"
                className="mx-2"
                onClick={handleSubmitInvoice}
                disabled={
                  procList
                    ? entity_type === "Seller"
                      ? procList.document_status?.b2s_invoice || procList.document_status?.normal_invoice
                      : entity_type === "Procurement Admin"
                      ? procList.document_state?.b2s_invoice || procList.document_state?.normal_invoice
                      : generatedInvoices?.length > 0
                    : false
                }
                
              >
                Generate Invoice &nbsp;
                {showLoading ? <Spinner size="sm" /> : ""}
              </Button>
            </div>
          </Col>
        </Row>
        {generatedInvoices?.length > 0 ? (
          <>
            <h4 className="mt-4 mx-3">Generated Invoice</h4>
            <Table striped hover className="" responsive>
              <thead>
                <tr>
                  <th className="th-sm">Quantity</th>
                  <th className="th-sm">Download Invoice</th>
                </tr>
              </thead>
              <tbody>
                {generatedInvoices?.map((field, index) => (
                  <tr key={index}>
                    <td>
                      {field.quantity} {procList.unit_of_measure}
                    </td>
                    <td>
                      {field?.invoice_documents
                        ?.filter((item) => {
                          if (entity_type === "Seller") {
                            return item.file.includes("invoice_1");
                          }
                          return true;
                        })
                        ?.map((item, idx) => (
                          <Tooltip title={`Invoice`} key={idx}>
                            <Button
                              variant="contained"
                              color="primary"
                              size="small"
                              className="mx-1 mt-1"
                              onClick={() => handleDownload(item.file)}
                            >
                              <span className="mdi mdi-download cursor-pointer text-warning"></span>
                            </Button>
                          </Tooltip>
                        ))}
                    </td>

                    {/* <td>
              
              {field?.invoice_documents?.map((item, idx) => (
                <div key={idx}>
                  <span>{item.entity_type}</span>
                </div>
              ))}
            </td> */}
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default InvoiceGenerationAdmin;
